import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { any } from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  alertNew: {
    backgroundColor: '#FFEBEC',
    borderColor: theme.palette.error.main,
    borderRadius: theme.spacing(1),
    '&.MuiAlert-message': {
      color: theme.palette.error.main
    },
    '&.MuiAlert-root': {
      padding: theme.spacing(0, 2)
    }
  }
}));

export default function AlertContent({ icon, children }) {
  const classes = useStyles();

  return (
    <Alert
      variant="outlined"
      severity="error"
      icon={icon}
      className={classes.alertNew}
    >
      {children}
    </Alert>
  );
}

AlertContent.propTypes = {
  icon: any,
  children: any
};

AlertContent.defaultProps = {
  icon: null,
  children: null
};
